import CountdownTimer from '../components/CountdownTimer';

export default function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center relative" style={{backgroundColor: '#3d4f3d'}}>
      {/* Corner decorations - top left */}
      <div className="absolute top-8 left-8 opacity-20 hidden lg:block">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
          <path d="M 10,10 Q 10,35 25,40 Q 10,45 10,70" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <path d="M 10,10 Q 35,10 40,25 Q 45,10 70,10" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <circle cx="25" cy="25" r="2.5" fill="#d4c5a0"/>
          <path d="M 18,18 L 22,22 M 28,15 L 32,19 M 15,28 L 19,32" stroke="#d4c5a0" strokeWidth="1" opacity="0.6"/>
        </svg>
      </div>
      
      {/* Corner decorations - top right */}
      <div className="absolute top-8 right-8 opacity-20 hidden lg:block" style={{transform: 'scaleX(-1)'}}>
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
          <path d="M 10,10 Q 10,35 25,40 Q 10,45 10,70" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <path d="M 10,10 Q 35,10 40,25 Q 45,10 70,10" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <circle cx="25" cy="25" r="2.5" fill="#d4c5a0"/>
          <path d="M 18,18 L 22,22 M 28,15 L 32,19 M 15,28 L 19,32" stroke="#d4c5a0" strokeWidth="1" opacity="0.6"/>
        </svg>
      </div>
      
      {/* Corner decorations - bottom left */}
      <div className="absolute bottom-8 left-8 opacity-20 hidden lg:block" style={{transform: 'scaleY(-1)'}}>
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
          <path d="M 10,10 Q 10,35 25,40 Q 10,45 10,70" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <path d="M 10,10 Q 35,10 40,25 Q 45,10 70,10" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <circle cx="25" cy="25" r="2.5" fill="#d4c5a0"/>
          <path d="M 18,18 L 22,22 M 28,15 L 32,19 M 15,28 L 19,32" stroke="#d4c5a0" strokeWidth="1" opacity="0.6"/>
        </svg>
      </div>
      
      {/* Corner decorations - bottom right */}
      <div className="absolute bottom-8 right-8 opacity-20 hidden lg:block" style={{transform: 'scale(-1, -1)'}}>
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
          <path d="M 10,10 Q 10,35 25,40 Q 10,45 10,70" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <path d="M 10,10 Q 35,10 40,25 Q 45,10 70,10" stroke="#d4c5a0" strokeWidth="1.5" fill="none"/>
          <circle cx="25" cy="25" r="2.5" fill="#d4c5a0"/>
          <path d="M 18,18 L 22,22 M 28,15 L 32,19 M 15,28 L 19,32" stroke="#d4c5a0" strokeWidth="1" opacity="0.6"/>
        </svg>
      </div>
      
      {/* Left gothic arch pillar - Clean design */}
      <div className="absolute left-0 hidden lg:block" style={{top: 'calc(2rem + 90px)', bottom: 'calc(2rem + 90px)', opacity: 0.25}}>
        <svg width="90" height="100%" viewBox="0 0 90 600" preserveAspectRatio="none" fill="none" style={{height: '100%'}}>
          {/* Stone pillar columns */}
          <line x1="20" y1="35" x2="20" y2="575" stroke="#d4c5a0" strokeWidth="3" opacity="0.6"/>
          <line x1="40" y1="35" x2="40" y2="575" stroke="#d4c5a0" strokeWidth="3" opacity="0.6"/>
          
          {/* Top capital - floral design */}
          <rect x="18" y="25" width="24" height="8" fill="#d4c5a0" opacity="0.7"/>
          <line x1="18" y1="25" x2="42" y2="25" stroke="#d4c5a0" strokeWidth="1.5" opacity="0.8"/>
          
          {/* Floral petals/leaves radiating upward */}
          <path d="M 30,25 Q 25,18 22,10 Q 20,5 18,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.6"/>
          <path d="M 30,25 Q 35,18 38,10 Q 40,5 42,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.6"/>
          <path d="M 30,25 Q 28,15 28,8 Q 28,4 28,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.65"/>
          <path d="M 30,25 Q 32,15 32,8 Q 32,4 32,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.65"/>
          
          {/* Small decorative leaves on petals */}
          <ellipse cx="25" cy="12" rx="3" ry="5" fill="#d4c5a0" opacity="0.4" transform="rotate(-30 25 12)"/>
          <ellipse cx="35" cy="12" rx="3" ry="5" fill="#d4c5a0" opacity="0.4" transform="rotate(30 35 12)"/>
          <ellipse cx="28" cy="8" rx="2.5" ry="4" fill="#d4c5a0" opacity="0.45"/>
          <ellipse cx="32" cy="8" rx="2.5" ry="4" fill="#d4c5a0" opacity="0.45"/>
          
          {/* Connecting curves from capital to pillar */}
          <path d="M 18,33 Q 20,35 20,35" stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.5"/>
          <path d="M 42,33 Q 40,35 40,35" stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.5"/>
          
          {/* Bottom base - two bars */}
          <rect x="18" y="575" width="24" height="6" fill="#d4c5a0" opacity="0.65"/>
          <rect x="16" y="581" width="28" height="8" fill="#d4c5a0" opacity="0.7"/>
          <line x1="16" y1="581" x2="44" y2="581" stroke="#d4c5a0" strokeWidth="1.5" opacity="0.8"/>
          
          {/* Vines wrapping around pillar */}
          <path d="M 15,35 Q 25,65 20,95 Q 15,125 25,155 Q 35,185 25,215 Q 15,245 30,275 Q 45,305 30,335 Q 15,365 25,395 Q 35,425 25,455 Q 15,485 30,515 Q 45,545 30,565 Q 20,570 25,575" 
                stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.7"/>
          <path d="M 45,35 Q 35,65 40,95 Q 45,125 35,155 Q 25,185 35,215 Q 45,245 30,275 Q 15,305 30,335 Q 45,365 35,395 Q 25,425 35,455 Q 45,485 30,515 Q 15,545 35,565 Q 40,570 35,575" 
                stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.7"/>
          
          {/* Leaves along vines */}
          <path d="M 25,65 Q 30,60 28,70 Q 25,65 25,65" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 20,125 Q 15,120 17,130 Q 20,125 20,125" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 28,185 Q 33,180 31,190 Q 28,185 28,185" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,245 Q 35,240 33,250 Q 30,245 30,245" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,305 Q 20,300 22,310 Q 25,305 25,305" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,365 Q 35,360 33,370 Q 30,365 30,365" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,425 Q 20,420 22,430 Q 25,425 25,425" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,485 Q 35,480 33,490 Q 30,485 30,485" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,545 Q 20,540 22,550 Q 25,545 25,545" fill="#d4c5a0" opacity="0.5"/>
        </svg>
      </div>
      
      {/* Right pillar with vines - mirror of left */}
      <div className="absolute right-0 hidden lg:block" style={{top: 'calc(2rem + 90px)', bottom: 'calc(2rem + 90px)', opacity: 0.25, transform: 'scaleX(-1)'}}>
        <svg width="90" height="100%" viewBox="0 0 90 600" preserveAspectRatio="none" fill="none" style={{height: '100%'}}>
          {/* Stone pillar columns */}
          <line x1="20" y1="35" x2="20" y2="575" stroke="#d4c5a0" strokeWidth="3" opacity="0.6"/>
          <line x1="40" y1="35" x2="40" y2="575" stroke="#d4c5a0" strokeWidth="3" opacity="0.6"/>
          
          {/* Top capital - floral design */}
          <rect x="18" y="25" width="24" height="8" fill="#d4c5a0" opacity="0.7"/>
          <line x1="18" y1="25" x2="42" y2="25" stroke="#d4c5a0" strokeWidth="1.5" opacity="0.8"/>
          
          {/* Floral petals/leaves radiating upward */}
          <path d="M 30,25 Q 25,18 22,10 Q 20,5 18,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.6"/>
          <path d="M 30,25 Q 35,18 38,10 Q 40,5 42,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.6"/>
          <path d="M 30,25 Q 28,15 28,8 Q 28,4 28,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.65"/>
          <path d="M 30,25 Q 32,15 32,8 Q 32,4 32,0" stroke="#d4c5a0" strokeWidth="2" fill="none" opacity="0.65"/>
          
          {/* Small decorative leaves on petals */}
          <ellipse cx="25" cy="12" rx="3" ry="5" fill="#d4c5a0" opacity="0.4" transform="rotate(-30 25 12)"/>
          <ellipse cx="35" cy="12" rx="3" ry="5" fill="#d4c5a0" opacity="0.4" transform="rotate(30 35 12)"/>
          <ellipse cx="28" cy="8" rx="2.5" ry="4" fill="#d4c5a0" opacity="0.45"/>
          <ellipse cx="32" cy="8" rx="2.5" ry="4" fill="#d4c5a0" opacity="0.45"/>
          
          {/* Connecting curves from capital to pillar */}
          <path d="M 18,33 Q 20,35 20,35" stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.5"/>
          <path d="M 42,33 Q 40,35 40,35" stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.5"/>
          
          {/* Bottom base - two bars */}
          <rect x="18" y="575" width="24" height="6" fill="#d4c5a0" opacity="0.65"/>
          <rect x="16" y="581" width="28" height="8" fill="#d4c5a0" opacity="0.7"/>
          <line x1="16" y1="581" x2="44" y2="581" stroke="#d4c5a0" strokeWidth="1.5" opacity="0.8"/>
          
          {/* Vines wrapping around pillar */}
          <path d="M 15,35 Q 25,65 20,95 Q 15,125 25,155 Q 35,185 25,215 Q 15,245 30,275 Q 45,305 30,335 Q 15,365 25,395 Q 35,425 25,455 Q 15,485 30,515 Q 45,545 30,565 Q 20,570 25,575" 
                stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.7"/>
          <path d="M 45,35 Q 35,65 40,95 Q 45,125 35,155 Q 25,185 35,215 Q 45,245 30,275 Q 15,305 30,335 Q 45,365 35,395 Q 25,425 35,455 Q 45,485 30,515 Q 15,545 35,565 Q 40,570 35,575" 
                stroke="#d4c5a0" strokeWidth="1.5" fill="none" opacity="0.7"/>
          
          {/* Leaves along vines */}
          <path d="M 25,65 Q 30,60 28,70 Q 25,65 25,65" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 20,125 Q 15,120 17,130 Q 20,125 20,125" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 28,185 Q 33,180 31,190 Q 28,185 28,185" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,245 Q 35,240 33,250 Q 30,245 30,245" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,305 Q 20,300 22,310 Q 25,305 25,305" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,365 Q 35,360 33,370 Q 30,365 30,365" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,425 Q 20,420 22,430 Q 25,425 25,425" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 30,485 Q 35,480 33,490 Q 30,485 30,485" fill="#d4c5a0" opacity="0.5"/>
          <path d="M 25,545 Q 20,540 22,550 Q 25,545 25,545" fill="#d4c5a0" opacity="0.5"/>
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-24 pb-16 text-center relative z-10">
        {/* Names in script font */}
        <h1 className="text-6xl md:text-7xl mb-12 leading-tight" style={{color: '#d4c5a0', fontFamily: 'Great Vibes', fontWeight: 400}}>
          Becca <span style={{fontFamily: 'Tenor Sans', fontSize: '0.35em', fontStyle: 'italic', fontWeight: 300}}>and</span> James
        </h1>

        {/* Request text */}
        <p className="text-sm tracking-widest mb-8" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.2em'}}>
          REQUEST THAT YOU JOIN THEM AT THE
        </p>

        {/* Venue and Date */}
        <div className="flex items-center justify-center gap-8 mb-8">
          <div className="text-left">
            <p className="text-sm tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Cinzel', letterSpacing: '0.15em'}}>
              FIELD PLACE
            </p>
            <p className="text-sm tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Cinzel', letterSpacing: '0.15em'}}>
              MANOR AND
            </p>
            <p className="text-sm tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Cinzel', letterSpacing: '0.15em'}}>
              BARNS
            </p>
          </div>
          
          <div className="w-px h-16" style={{backgroundColor: '#d4c5a0'}}></div>
          
          <div className="text-center">
            <p className="text-5xl" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', fontWeight: 300}}>
              24<span style={{fontSize: '0.7em'}}>/</span>10
            </p>
          </div>
        </div>

        {/* Celebrate text */}
        <p className="text-sm tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.2em'}}>
          TO CELEBRATE THEIR MARRIAGE
        </p>

        {/* Countdown Timer */}
        <CountdownTimer />
      </div>
    </div>
  );
}
